// extracted by mini-css-extract-plugin
export default {"refreshSelect":"SummarySections_refreshSelect__HMr5e","lockedNote":"SummarySections_lockedNote__bYhmS","editCard":"SummarySections_editCard__kZ2xD"};